// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bie_a bie_x bie_j bie_u bie_bc bie_ql bie_vv"};